/**
 * TakeawayBlock: the one-line marketer so-what, rendered as a subtle callout (soft
 * surface, desk-lamp icon, no written label; "Takeaway" stays for screen readers).
 * Extracted from FocusGroupSummaryCard (Step 2, prose migration) so both the
 * legacy render and the new prose render can share the SAME takeaway visual.
 */
import { LampDesk } from '@digital-twins/design-system/icons'
import { useTranslation } from 'react-i18next'

export interface TakeawayBlockProps {
  /** The one-line so-what for the marketer. */
  text: string
  /** Override the default test id. */
  dataTestId?: string
}

export function TakeawayBlock({ text, dataTestId }: TakeawayBlockProps) {
  const { t } = useTranslation('app')
  return (
    <div
      className="mt-5 flex items-start gap-3 rounded-[10px] bg-muted px-4 py-3.5"
      data-testid={dataTestId ?? 'qs-focus-group-takeaway'}
    >
      <LampDesk className="mt-0.5 h-4 w-4 flex-none text-muted-foreground" aria-hidden="true" />
      <span className="sr-only">{t('quickStudyChrome.takeawaySr')}</span>
      <p className="text-[0.95rem] font-medium leading-relaxed text-foreground/90">{text}</p>
    </div>
  )
}

export default TakeawayBlock
